import { render, staticRenderFns } from "./WorkCalendarDropDialog.vue?vue&type=template&id=07b7cc2a&scoped=true"
import script from "./WorkCalendarDropDialog.vue?vue&type=script&lang=js"
export * from "./WorkCalendarDropDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendarDropDialog.vue?vue&type=style&index=0&id=07b7cc2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b7cc2a",
  null
  
)

export default component.exports